var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-app',{staticClass:"default-layout"},[_c('ProgressBar'),_c('MainNotifications'),_c('SideNav',{attrs:{"getMyyInfo":this.userInfo}}),_c('v-main',{staticClass:"default-layout__main"},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }